// extracted by mini-css-extract-plugin
export default {"bg":"modal_bg__bS3UX","body":"modal_body__KW5tE","cancel_button":"modal_cancel_button__Y7vqK"};